module.exports = __webpack_public_path__ + "packs/media/images/news_1-a1f26c2c8900eea4ea0f1a48542c8d63.jpg";